import React from 'react';
import { Card } from '@material-ui/core';

const ClassRequest = (props) => {
  
  const renderHeading =
    props.classRequestsData.length > 0 ? "Class join request sent!" : "No classes found!"

  const renderSubtitle = 
    props.classRequestsData.length > 0 ? "Your join request is received by administrator of your institute." : "Join a class to start using Kneura"

  return (
    <div style={container}>
      <Card sx={{ width: 100 }}>
        <div style={card}>
          <div style={heading}>{renderHeading}</div>
          <div style={subtitle}>
            {renderSubtitle}
          </div>
        </div>
      </Card>
    </div>
  );
};

const container = {
  display: 'flex',
  backgroundColor: '#EDEFF1',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
};

const card = {
  padding: 25,
  fontFamily: 'Poppins',
};

const heading = {
  fontSize: '2rem',
  fontWeight: 400,
};

const subtitle = {
  fontSize: '.75rem',
  color: '#34495EBF',
  opacity: '0.75',
  marginTop: 20,
};
export default ClassRequest;
